import React, { Component } from "react";

class KvkkModalFooter extends Component {
  state = {
    kvkkCheck: false,
  };

  handleKvkkCheck = (e) => {
    this.setState({ kvkkCheck: e.target.checked });
    // this.renderKvkkModal();
  };

  handleKvkkApprove = () => {
    if (this.state.kvkkCheck) {
      this.props.handleKvkkApprove();
    }
  };

  render() {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateRows: "auto",
          gridTemplateColumns: "1fr 1fr",
        }}
      >
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id="kvkkCheck"
            onChange={(e) => this.handleKvkkCheck(e)}
            checked={this.state.kvkkCheck}
          />
          <label
            className="custom-control-label pl-0 formClickArea"
            htmlFor="kvkkCheck"
          >
            <span> Okudum, anladım, onaylıyorum</span>
          </label>
        </div>
        <div style={{ justifySelf: "end" }}>
          <button
            type="submit"
            className="btn btn-fga-primary"
            onClick={(e) => this.handleKvkkApprove(e)}
          >
            Kaydet
          </button>
        </div>
      </div>
    );
  }
}

export default KvkkModalFooter;
